

import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";

import { AgGridReact } from '@ag-grid-community/react';
import { invert, map } from 'lodash';
import { forwardRef, memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { useStateIfMounted } from 'use-state-if-mounted';
// import SymbolCellRenderer from './SymbolCellRenderer';
// import '@ag-grid-community/styles/ag-grid.css';
// import './ag-grid-custom.css'; //override ag-grid-community/styles/ag-grid.css /* https://unpkg.com/@ag-grid-community/styles@31.2.1/ag-grid.css */
// import './ag-grid.css'; //override ag-grid-community/styles/ag-grid.css /* https://unpkg.com/@ag-grid-community/styles@31.2.1/ag-grid.css */
// import './SymbolSelectorTableNew.css'; //
// import './ag-grid.css'; //override ag-grid-community/styles/ag-grid.css /* https://unpkg.com/@ag-grid-community/styles@31.2.1/ag-grid.css */
// import './SymbolSelectorTableNew.scss';
// import '@ag-grid-community/styles/ag-theme-alpine.css';
import { SymbolCollectionTypes } from "@/stores/dataStore/memoryStore/const/constIndex";
import Random from '@/utilities/random';
// import CommonUtils from '@/utilities/utils';
import RenderGridCellRealTimePriceBoard from '@/views/components/Priceboard/SymbolSelectorNew/RenderGridCellRealTimePriceBoard';
import SymbolSelectorMenu from "../SymbolSelectorMenu/SymbolSelectorMenu";
import { divide, roundToTwo } from "@npm_dev/fss-utilities";
// const RenderGridCellRealTimePriceBoard = lazy(() => import(/* webpackChunkName: "RT" */ "@/views/components/Priceboard/SymbolSelectorNew/RenderGridCellRealTimePriceBoard"));
// import RenderGridCellRealTimePriceBoard from '@/views/components/Priceboard/SymbolSelectorNew/RenderGridCellRealTimePriceBoard';
// import { GridReadyEvent, ModuleRegistry } from '@ag-grid-community/core';
// ModuleRegistry.registerModules([ClientSideRowModelModule]); // Đăng ký các module cần thiết

// https://ag-grid.com/react-data-grid/data-update-high-frequency/
// https://www.ag-grid.com/javascript-data-grid/change-cell-renderers/
// https://codesandbox.io/p/sandbox/refresh-cells-3tn3gs?file=%2Fsrc%2Findex.js%3A111%2C1-115%2C46






// if (window.MutationObserver) {
//     console.log("MutationObserver được hỗ trợ");
// } else {
//     console.log("MutationObserver không được hỗ trợ trên trình duyệt này");
// }
// Tạo một MutationObserver để giám sát các thay đổi trong DOM
// const observer = new MutationObserver((mutationsList) => {
//     mutationsList.forEach(mutation => {
//         mutation.addedNodes.forEach(node => {
//             // Kiểm tra nếu node là một Element (nodeType === 1)
//             console.log("MutationObserver node 1", node)
//             if (node instanceof HTMLElement && node.classList.contains('ag-theme-classic')) {
//                 console.log("MutationObserver node", node, node.nodeType, node.classList)
//                 node.remove(); // Xóa phần tử nếu có class 'class-name'
//             }
//         });
//     });
// });

// observer.observe(document.body, {
//     childList: true,  // Theo dõi các thay đổi liên quan đến con của phần tử
//     subtree: true     // Theo dõi các thay đổi trong tất cả các phần tử con
// });



// const observer = new MutationObserver((mutationsList) => {
//     mutationsList.forEach(mutation => {
//         if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
//             const node = mutation.target;
//             if (node instanceof HTMLElement && node.classList.contains('ag-hidden')) {
//                 console.log('Class "class-name" được gán và phần tử sẽ bị xóa:', node);
//                 node.remove(); // Xóa phần tử khi class "class-name" được gán
//             }
//         }
//     });
// });

// // Theo dõi các thay đổi thuộc tính và phần tử con
// observer.observe(document.body, {
//     attributes: true,  // Theo dõi thay đổi thuộc tính
//     childList: true,   // Theo dõi thay đổi trong phần tử con
//     subtree: true      // Theo dõi trong tất cả các phần tử con cấp dưới
// });


const is_vitrual_scroll = true
const animateClass = {
    GREEN: 'ag-cell-pb-isNew-green',
    RED: 'ag-cell-pb-isNew-red',
    CEIL: 'ag-cell-pb-isNew-ceil',
    FLOOR: 'ag-cell-pb-isNew-floor',
    REF: 'ag-cell-pb-isNew-ref',
    BLANK: 'ag-cell-pb-isNew-blank',
    PRICE_STRING: 'ag-cell-pb-isNew-price-string', // ATO, ATC
    VOLUMN: 'ag-cell-pb-isNew-Volumn',
    BLOCK_HIGHLIGHT_BACKGROUND: 'pb-Block-Highlight-Background'
}

const SymbolSelectorTableNew = (props: any) => {
    let containerStyle: any = useMemo(() => ({ width: '100%', height: '100%' }), []);
    let gridStyle: any = useMemo(() => ({ height: '100%', width: '100%' }), []);
    let gridRef: any = useRef();
    let prevIdTablePb: any = useRef();
    let scrollTimerRef: any = useRef();
    let DATA_TYPE_VOLUME: any = 'VOLUME';
    let DATA_TYPE_PRICE: any = 'PRICE';
    let DATA_TYPE_PRICE_DIFF: any = 'PRICE_DIFF';
    let DATA_TYPE_PERCENT_DIFF: any = 'PERCENT_DIFF';
    const listMapsPrice: any = {
        "CP": "CV",
        //----------
        "S1": "U1",
        "S2": "U2",
        "S3": "U3",
        //----------
        "B1": "V1",
        "B2": "V2",
        "B3": "V3",
    }
    const listMapsVolumn = invert(listMapsPrice);
    const listPriceString = "ATO||ATC";
    function getAnimationClass(params: any) {
        let { value, data: oldDataRow, cellRendererParams } = params
        let priceToCompare = value;
        let dataField = cellRendererParams.dataField
        let classCompare: any = ""
        if (oldDataRow) {
            if (listMapsVolumn.hasOwnProperty(dataField)) {
                if (priceToCompare == oldDataRow[`${dataField}_OLD`]) {
                    // Chặn highlight khi khối lượng không thay đổi nhưng giá thay đổi, chỉ update lại màu của text
                    classCompare = [animateClass.BLOCK_HIGHLIGHT_BACKGROUND]
                }
            }
            if (oldDataRow.bySocketUpdate !== true) {
                // Chặn highlight khi call api instrument
                classCompare = [animateClass.BLOCK_HIGHLIGHT_BACKGROUND]
            }
        }
        if (cellRendererParams && cellRendererParams.compareField) {
            priceToCompare = oldDataRow && oldDataRow[cellRendererParams.compareField]
            if (listPriceString.indexOf(priceToCompare) > -1) {
                return [animateClass.PRICE_STRING, classCompare]
            }
            if (!priceToCompare || priceToCompare == 0 || priceToCompare == "0") {
                return [animateClass.REF, classCompare]
            }
        }
        if (listPriceString.indexOf(priceToCompare) > -1) {
            return [animateClass.PRICE_STRING, classCompare]
        }
        let ceilPrice = oldDataRow ? oldDataRow.CL : 0;
        let floorPrice = oldDataRow ? oldDataRow.FL : 0;
        let refPrice = oldDataRow ? oldDataRow.RE : 0;
        if (priceToCompare * 1 == ceilPrice) {
            return [animateClass.CEIL, classCompare]
        }
        if (priceToCompare * 1 == floorPrice) {
            return [animateClass.FLOOR, classCompare]
        }
        if (priceToCompare * 1 == refPrice) {
            return [animateClass.REF, classCompare]
        }
        // if(textPrices.includes(priceToCompare)){
        //     return [animateClass.BLANK]
        // }
        if (priceToCompare * 1 > refPrice) {
            return [animateClass.GREEN, classCompare]
        }
        if (priceToCompare * 1 < refPrice) {
            return [animateClass.RED, classCompare]
        }
        return [classCompare]
    }

    function getAnimationClassForVolumn(params: any) {
        let { bySocketUpdate } = params
        let classCompare: any = ""
        if (bySocketUpdate !== true) {
            // Chặn highlight khi call api instrument
            classCompare = [animateClass.BLOCK_HIGHLIGHT_BACKGROUND]
        }
        return [animateClass.VOLUMN, classCompare]
    }

    // function CustomHeader(params) {
    //     const [statusSort, setStatusSort] = useStateIfMounted('');
    //     const [ascSort, setAscSort] = useStateIfMounted('inactive');
    //     const [descSort, setDescSort] = useStateIfMounted('inactive');
    //     const [noSort, setNoSort] = useStateIfMounted('inactive');
    //     useEffect(() => {
    //         params.setSort(statusSort);
    //     }, [statusSort])

    //     useEffect(() => {
    //         params.column.addEventListener('sortChanged', onSortChanged);
    //         onSortChanged();
    //         return () => {
    //             params.column.removeEventListener('sortChanged', onSortChanged);
    //         }
    //     }, []);
    //     const onSortChanged = () => {
    //         setAscSort(params.column.isSortAscending() ? 'active' : 'inactive');
    //         setDescSort(params.column.isSortDescending() ? 'active' : 'inactive');
    //         setNoSort(!params.column.isSortAscending() && !params.column.isSortDescending() ? 'active' : 'inactive');
    //     }

    //     const onSortRequested = (event) => {
    //         //Key sort theo thứ tự: tăng dần --> giảm dần --> về trạng thái ko sắp xếp
    //         if (statusSort == 'asc') setStatusSort('desc');
    //         if (statusSort == 'desc') setStatusSort('');
    //         if (statusSort == '') setStatusSort('asc');
    //     };
    //     return (
    //         <div id={"toolTipHeader" + params.displayName} className="header-custom" onClick={(event) => onSortRequested(event)} onTouchEnd={(event) => onSortRequested(event)}>
    //             {ascSort == 'active' && (
    //                 <span className="fa fa-arrow-up icon-sort" unselectable="on" role="presentation"></span>
    //             )}
    //             {descSort == 'active' && (
    //                 <span className="fa fa-arrow-down icon-sort" unselectable="on" role="presentation"></span>
    //             )}
    //         </div>
    //     )
    // }

    // function CustomGroupHeader(params) {
    //     return (
    //         <div className="ag-header-group-text">
    //         </div>
    //     )
    // }

    function customNumberComparator(number1: any, number2: any) {
        //Sắp xếp theo null --> ATO, ATC --> Số (riêng cho giá 1 bên mua bên bán vì trộn kiểu dữ liệu string với number nên cần custom compare)
        if (number1 === null && number2 === null) {
            return 0;
        }
        if (!number1) return -1;
        if (!number2) return 1;
        if (number1 == "ATO" || number1 == "ATC") return -1;
        if (number2 == "ATO" || number2 == "ATC") return 1;
        return parseFloat(number1) - parseFloat(number2);
    }

    const formatNumber = (value: any, type: any, Digits: any, dataField?: any, dataRow?: any) => {
        let { isOddlot, isDerivatives, isBond, isCorpBondPriceBoard } = props
        // console.debug("formatNumber.:", value, isOddlot, isDerivatives, isBond, isCorpBondPriceBoard)
        if (value == null) {
            return null;
        }
        value = parseFloat(value) || value
        if (type == "price") {
            if (value == 0) {
                return ""
            }
            if (typeof value === 'number') {
                // value = Number(value) / 1000
                if (isDerivatives) {
                    Digits = 1
                    if (dataField == 'AP') {
                        value = divide(value, 100000)
                    }
                } else {
                    value = divide(value, 1000)
                }
                if (isBond) {
                    Digits = 3
                }
                return value.toLocaleString(undefined, { maximumFractionDigits: Digits })
            }
        }
        if (type == "volumn") {
            if (value == 0) {
                return ""
            }
            if (typeof value === 'number') {
                if (isCorpBondPriceBoard && dataField === 'PTV') {
                    value = roundToTwo(value, 1000000)
                } else {
                    value = (isOddlot || isDerivatives || isCorpBondPriceBoard) ? value : divide(value, 1000)
                }
                // value = Number(value) / 1000
                return value.toLocaleString(undefined, { maximumFractionDigits: Digits })
            }
        }

        if (type == "volumnNN") {
            if (value == 0) {
                return ""
            }
            if (typeof value === 'number') {
                if (isCorpBondPriceBoard && dataField === 'PTV') {
                    value = roundToTwo(value, 1000000)
                } else {
                    value = (isOddlot || isDerivatives || isCorpBondPriceBoard) ? value : divide(value, 1000)
                }
                if (value >= 100000) {
                    Digits = 1
                }
                return value.toLocaleString(undefined, { maximumFractionDigits: Digits })
            }
        }


        if (type == "changed") {
            value = (isDerivatives) ? value : divide(value, 1000)
            if (typeof value === 'number') {
                if (isNaN(value)) {
                    return ""
                }
                let incText = ""
                if (value > 0) {
                    incText = "+"
                }
                return `${incText}${value.toLocaleString(undefined, { maximumFractionDigits: Digits })}`
            }
            return ""
        }


        if (type == "percent") {
            if (dataRow && (dataRow.CP == 0 || dataRow.CP == undefined || dataRow.CP == null)) {
                value = ""
            }
            else {
                value = Number(value) / 1000
                if (typeof value === 'number') {
                    if (value == 0 || isNaN(value)) {
                        return "0%"
                    }
                    let incText = ""
                    if (value > 0) {
                        incText = "+"
                    }
                    return `${incText}${value.toLocaleString(undefined, { maximumFractionDigits: Digits })}%`
                }
            }
            return ""
        }
        return value
    }

    function _columns(collectionTypes: any) {
        return [
            {
                headerName: 'TC',
                // // headerComponent: CustomHeader,
                field: 'RE',
                // suppressSizeToFit: true,
                //maxWidth: '63',
                //width: widthDefault + '',
                minWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '60' : '49',
                maxWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '70' : '63',
                //flex: 1,
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "RE",
                    dataType: DATA_TYPE_PRICE,
                    shortForm: true,
                    isPlaceOrder: true,
                },
                tooltipField: "RE",
                // tooltipValueGetter: (p) =>
                // "Create any fixed message, e.g. This is the Athlete’s Age ",
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                cellClass: ['cell-value-right', 'txt-p---400-13', 'highligh-column', 'ag-cell-color-ref', 'label-button'],
                headerClass: ['txt-p---400-13'],
            },
            {
                headerName: 'Trần',
                // headerComponent: CustomHeader,
                // tooltipValueGetter: tooltipValueGetter,
                field: 'CL',
                // suppressSizeToFit: true,
                //maxWidth: '65',
                minWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '60' : '49',
                maxWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '70' : '63',
                //flex: 2,
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "CL",
                    dataType: DATA_TYPE_PRICE,
                    shortForm: true,
                    isPlaceOrder: true,
                },
                tooltipField: "CL",
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                cellClass: ['cell-value-right', 'txt-p---400-13', 'highligh-column', 'ag-cell-color-ceil', 'label-button'],
                headerClass: ['txt-p---400-13'],

            },
            {
                headerName: 'Sàn',
                // headerComponent: CustomHeader,
                field: 'FL',
                // suppressSizeToFit: true,
                //maxWidth: '68',
                minWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '60' : '49',
                maxWidth: collectionTypes == SymbolCollectionTypes.BONDS ? '70' : '63',
                //flex: 3,
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "FL",
                    dataType: DATA_TYPE_PRICE,
                    shortForm: true,
                    isPlaceOrder: true,
                },
                tooltipField: "FL",
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                cellClass: ['cell-value-right', 'txt-p---400-13', 'highligh-column', 'ag-cell-color-floor', 'label-button'],
                headerClass: ['txt-p---400-13'],
            },
            {
                headerName: 'Bên mua',
                // headerGroupComponent: CustomGroupHeader,
                headerClass: ['txt-p---400-13'],
                children: [
                    {
                        field: 'B3',
                        headerName: 'Giá 3',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 4,
                        minWidth: '44',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "B3",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'B3',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'V3',
                        headerName: 'KL 3',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 5,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "V3",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "B3",
                            shortForm: true,
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'B2',
                        headerName: 'Giá 2',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        ////flex: 6,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "B2",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'B2',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'V2',
                        headerName: 'KL 2',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 7,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "V2",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "B2",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'B1',
                        headerName: 'Giá 1',
                        // headerComponent: CustomHeader,
                        comparator: customNumberComparator,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 8,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "B1",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'B1',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'V1',
                        headerName: 'KL 1',
                        // headerComponent: CustomHeader,
                        //maxWidth: '65',
                        //flex: 9,
                        //suppressSizeToFit: true,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "V1",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "B1",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                ],
            },
            {
                headerName: 'Khớp lệnh',
                // headerGroupComponent: CustomGroupHeader,
                headerClass: ['txt-p---400-13'],
                children: [
                    {
                        headerName: 'Mã CK',
                        // headerComponent: CustomHeader,
                        field: 'SB',
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 10,
                        minWidth: '90',
                        // cellRenderer: (params: any) => SymbolCellRenderer(params, props),
                        enableCellChangeFlash: false,
                        cellClass: ['cell-value-left', 'txt-p---400-13', 'highligh-column'],
                        headerClass: ['txt-p---400-13'],
                        //suppressMovable: true, //Được kéo thả cột
                    },
                    {
                        field: 'CP',
                        headerName: 'Giá',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '64',
                        //flex: 11,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "CP",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null,
                        },
                        tooltipField: 'CP',
                        enableCellChangeFlash: true,
                        // readOnlyEdit: false,
                        // cellEditRequest: false,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'CV',
                        headerName: 'KL',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '64',
                        //flex: 12,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "CV",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "CP",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'CH',
                        headerName: '+/-',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '64',
                        //flex: 13,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "CH",
                            dataType: DATA_TYPE_PRICE_DIFF,
                            compareField: "CP",
                            shortForm: true,
                            isFormatZero: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "changed", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'percent',
                        headerName: '%',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '64',
                        //flex: 14,
                        minWidth: '55',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "percent",
                            dataType: DATA_TYPE_PERCENT_DIFF,
                            compareField: "CP",
                            shortForm: true,
                            isFormatZero: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "percent", 2, "percent", params.data),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                ],
            },
            {
                headerName: 'Bên bán',
                // headerGroupComponent: CustomGroupHeader,
                headerClass: ['txt-p---400-13'],
                children: [
                    {
                        field: 'S1',
                        headerName: 'Giá 1',
                        // headerComponent: CustomHeader,
                        comparator: customNumberComparator,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 15,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "S1",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'S1',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'U1',
                        headerName: 'KL 1',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 16,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "U1",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "S1",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],

                    },
                    {
                        field: 'S2',
                        headerName: 'Giá 2',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 17,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "S2",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'S2',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'U2',
                        headerName: 'KL 2',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 18,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "U2",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "S2",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'S3',
                        headerName: 'Giá 3',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 19,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "S3",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'S3',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'U3',
                        headerName: 'KL 3',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 20,
                        minWidth: '50',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "U3",
                            dataType: DATA_TYPE_VOLUME,
                            compareField: "S3",
                            shortForm: true
                        },
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                ],
            },
            {
                headerName: 'Tổng KL',
                // headerComponent: CustomHeader,
                field: 'TT',
                //suppressSizeToFit: true,
                //maxWidth: '72',
                //flex: 21,
                minWidth: '72',
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "volumn", 2),
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "TT",
                    dataType: DATA_TYPE_VOLUME,
                    shortForm: true,
                    noColor: true
                },
                cellClass: (e: any) => {
                    return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClassForVolumn({ bySocketUpdate: e.data && e.data.bySocketUpdate })]
                },
                headerClass: ['txt-p---400-13']
            },
            {
                headerName: 'Giá',
                // headerGroupComponent: CustomGroupHeader,
                headerClass: ['txt-p---400-13'],
                children: [
                    {
                        field: 'HI',
                        headerName: 'Cao',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 22,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "HI",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'HI',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'AP',
                        headerName: 'TB',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 23,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "AP",
                            dataType: DATA_TYPE_PRICE,
                            //compareField: "B3",
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'AP',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2, 'AP'),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                    {
                        field: 'LO',
                        headerName: 'Thấp',
                        // headerComponent: CustomHeader,
                        //suppressSizeToFit: true,
                        //maxWidth: '65',
                        //flex: 24,
                        minWidth: '40',
                        // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                        cellRendererParams: {
                            dataField: "LO",
                            dataType: DATA_TYPE_PRICE,
                            shortForm: true,
                            isPlaceOrder: true,
                            actionOrder: null
                        },
                        tooltipField: 'LO',
                        enableCellChangeFlash: true,
                        valueFormatter: (params: any) => formatNumber(params.value, "price", 2),
                        cellClass: (e: any) => {
                            return [...['cell-value-right', 'txt-p---400-13', 'highligh-column', 'label-button'], ...getAnimationClass({ value: e.value, data: e.data, cellRendererParams: e.column.userProvidedColDef.cellRendererParams })]
                        },
                        headerClass: ['txt-p---400-13'],
                    },
                ],
            },
            {
                headerName: 'NN Mua',
                // headerComponent: CustomHeader,
                //suppressSizeToFit: true,
                //maxWidth: '72',
                //flex: 25,
                minWidth: '65',
                field: 'FB',
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "volumnNN", 3),
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "FB",
                    dataType: DATA_TYPE_VOLUME,
                    shortForm: true,
                    noColor: true //key không thay đổi màu giá theo giá thị trường
                },
                // cellClass: ['cell-value-right', 'txt-p---400-13'],
                cellClass: (e: any) => {
                    return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClassForVolumn({ bySocketUpdate: e.data && e.data.bySocketUpdate })]
                },
                headerClass: ['txt-p---400-13']
            },
            {
                headerName: 'NN Bán',
                // headerComponent: CustomHeader,
                //suppressSizeToFit: true,
                //maxWidth: '72',
                //flex: 26,
                minWidth: '65',
                field: 'FS',
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "volumnNN", 3),
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "FS",
                    dataType: DATA_TYPE_VOLUME,
                    shortForm: true,
                    noColor: true //key không thay đổi màu giá theo giá thị trường
                },
                // cellClass: ['cell-value-right', 'txt-p---400-13'],
                cellClass: (e: any) => {
                    return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClassForVolumn({ bySocketUpdate: e.data && e.data.bySocketUpdate })]
                },
                headerClass: ['txt-p---400-13']
            },
            {
                headerName: 'NN Room',
                // headerComponent: CustomHeader,
                //suppressSizeToFit: true,
                //maxWidth: '80',
                //flex: 27,
                minWidth: '80',
                field: 'FR',
                enableCellChangeFlash: true,
                valueFormatter: (params: any) => formatNumber(params.value, "volumnNN", 3),
                // cellRenderer: (params) => SymbolSelectorRowNew({ data: params.data, ...params.colDef.cellRendererParams }, { isLoggedIn: props.isLoggedIn, isOddlot: props.isOddlot, currentCollection: props.currentCollection, onPriceSelected: props.onPriceSelected }),
                cellRendererParams: {
                    dataField: "FR",
                    dataType: DATA_TYPE_VOLUME,
                    shortForm: true,
                    noColor: true //key không thay đổi màu giá theo giá thị trường
                },
                // cellClass: ['cell-value-right', 'txt-p---400-13'],
                cellClass: (e: any) => {
                    return [...['cell-value-right', 'txt-p---400-13'], ...getAnimationClassForVolumn({ bySocketUpdate: e.data && e.data.bySocketUpdate })]
                },
                headerClass: ['txt-p---400-13']
            },
        ];
    }

    const columns = (collectionTypes: any) => _columns(collectionTypes)

    const [rowData, setRowData] = useStateIfMounted<any>([]);
    const [idTablePb, setIdTablePb] = useStateIfMounted<any>('');
    const [pinnedTopRowDataArr, setPinnedTopRowDataArr] = useStateIfMounted<any>([]);
    const [columnDefs, setColumnDefs] = useStateIfMounted<any>(columns);
    const [isRenderView, setIsRenderView] = useStateIfMounted(false);
    const [isReady, setIsReady] = useStateIfMounted(false);


    const updateRowByKeyChanged = (row: any, instrument: any) => {
        map(Object.keys(instrument), (key) => {
            if (key !== 'SB') {
                row[key] = instrument[key]
                if (listMapsPrice.hasOwnProperty(key)) {
                    // key= CP
                    let keyMap = listMapsPrice[key]
                    // keyMap = CV
                    if (!instrument.hasOwnProperty(keyMap)) {
                        instrument.force = true;
                        instrument[`${keyMap}`] = row[`${keyMap}`];
                        row[`${keyMap}_OLD`] = row[`${keyMap}`];
                    } else {
                        row[`${keyMap}_OLD`] = undefined;
                    }
                }
            }
        })
        // Xóa các property không cần highlight theo list khai báo columns để fix lỗi cellComp render liên tục
        delete instrument.SB;

        return row
    }

    const applyTransactionAsyncRealtime = (obj: any, idTablePbByEmitter: any) => {
        try {
            let apiGrid = gridRef && gridRef.current && gridRef.current.api
            // apiGrid.ctrlsService = null // Nghi vấn tăng RAM nhưng Comment thi bi loi chuyen sang tab dat lenh
            if (apiGrid) {
                let { instrument } = obj
                if (instrument && instrument.SB) {
                    let row = apiGrid.getRowNode(instrument.SB);
                    // console.log("applyTransactionAsyncRealtime.:1", row.data.idTablePb, idTablePbByEmitter)
                    if (row && row.data && (row.data.idTablePb == idTablePbByEmitter)) {
                        if (instrument.bySocketUpdate && instrument.s < row.data.s) {
                            // logDebug(`SymbolSelectorTableNew.:updateRowByKeyChanged.:not_pinned.: not update by seq outdate`, { SB: row.data.SB, row_s: row.data.s, instrument_s: instrument.s, row: row.data, instrument })
                        } else {
                            // console.log("applyTransactionAsyncRealtime.:2")
                            row.data = updateRowByKeyChanged(row.data, instrument)
                            // Fix Error: AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.
                            apiGrid.refreshCells({
                                force: instrument.force || false, // true = Bỏ qua phát hiện thay đổi,luôn làm mới mọi thứ
                                columns: Object.keys(instrument),
                                rowNodes: [row],
                                suppressFlash: false // fix lỗi gây treo css highlight khi active lại tab
                            });
                            apiGrid = null
                            instrument = null
                            row = null
                            //   clearTimeout(timer)
                            // }, 0)
                        }
                    }
                }
            }
        } catch (e) {
            // logDebug(`SymbolSelectorTableNew.:msg.:i_3.:applyTransactionAsyncRealtime.Err=`, { err: e })
            // console.debug("applyTransactionAsyncRealtime.:", e)
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            //width: '68',
            //sortable: true, //có sort các col hay không
            tooltipComponent: () => {
                return ""
            },
        };
    }, []);

    useEffect(() => {
        let newArr = [];
        newArr = props.symbols;
        // console.log("newArr.:", newArr)
        let _idTableNew = Random.randomComponentId();
        const arrayRowDataNew = map(newArr, (v: any) => {
            // v.idTablePb = _idTableNew
            return { ...v, idTablePb: _idTableNew }
        })
        setRowData(arrayRowDataNew);
        setIdTablePb(_idTableNew);
        prevIdTablePb.current = _idTableNew
        // console.log("arrayRowDataNew.:", arrayRowDataNew, idTablePb)
    }, [props.listSymbols, isReady]);

    // const onGridReady = (params: GridReadyEvent) => {
    const onGridReady = () => {
        // console.log("onGridReady.:", params)
        setIsReady(true)
    }

    const sizeColumnsToFit = useCallback((params: any) => {
        params.api.sizeColumnsToFit();
        setIsRenderView(true)
    }, []);

    const onFirstDataRendered = useCallback((params: any) => {
        sizeColumnsToFit(params);
    }, []);

    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.refreshHeader()
        }
    }, [props.currentCollectionId]);

    useEffect(() => {
        if (props.isAutoScroll && rowData && rowData.length > 0) {
            //start auto srcoll
        } else {
            if (scrollTimerRef && scrollTimerRef.current) {
                //stop auto srcoll
                clearTimeout(scrollTimerRef.current)
            }
        }
    }, [props.isAutoScroll]);

    const onGridSizeChanged = useCallback((params: any) => {
        sizeColumnsToFit(params);
    }, []);

    const getThemeClass = () => {
        return "ag-theme-classic";
    }

    const modules = [
        // https://codesandbox.io/p/devbox/vibrant-feynman-v9yxo?file=%2Fsrc%2FrichGridDeclarativeExample%2FRichGridDeclarativeExample.jsx%3A16%2C41-16%2C81
        ClientSideRowModelModule,
    ]

    const onGridPreDestroyed = () => {
        setRowData([])
        setPinnedTopRowDataArr([])
        setColumnDefs([])
        setIsRenderView(false)
        // removeTheEmitter(idTablePb)

        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.destroy()
            gridRef.current = undefined
            gridRef = undefined
            // console.debug("Ag-grid.:destroyAgGrid.:gridRef.current.:", gridRef.current)
        }
        containerStyle = undefined
        gridStyle = undefined
        prevIdTablePb = undefined
        scrollTimerRef = undefined
        DATA_TYPE_VOLUME = undefined
        DATA_TYPE_PRICE = undefined
        DATA_TYPE_PRICE_DIFF = undefined
        DATA_TYPE_PERCENT_DIFF = undefined
    }
    // console.debug("Ag-grid.:onGridReady.:Render 22222222222222")
    // const autoSizeStrategy = {
    //   type: 'fitCellContents'
    // };

    const getRowId = useCallback((params: any) => params.data && params.data.SB, []); // set Id để update Realtime theo Id là mã CK
    // alert( props.symbols.length  )




    return (
        // (
        // props.symbols ? (
        <div className="SymbolSelectorTableNew" style={containerStyle}>
            {/* symbols: {props.symbols && props.symbols.length} -
                    rowData: {rowData && rowData.length} */}
            <div className="menu-pb">
                <SymbolSelectorMenu
                    idPbTab={props.idPbTab}
                    onChangeTabs={props.onChangeTabs}
                />
                {/* <button onClick={(e) => onChangeTabs(e, { idPbTab: "HOSE" })}>HOSE</button>
                <button onClick={(e) => onChangeTabs(e, { idPbTab: "HNX" })}>HNX</button>
                <button onClick={(e) => onChangeTabs(e, { idPbTab: "UPCOM" })}>UPCOM</button> */}
            </div>
            <div id="grid-priceboard" className={isRenderView ? "grid-priceboard" : "visibility"}>
                <div style={gridStyle} className={getThemeClass()}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        getRowId={getRowId}
                        rowHeight={28}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        // autoSizeStrategy={autoSizeStrategy}
                        columnHoverHighlight={true}
                        rowDragManaged={true} //cho phép được drag row
                        //rowDragEntireRow={true} //cho phép được drag row all col 
                        animateRows={true}
                        pinnedTopRowData={pinnedTopRowDataArr} //ghim row top
                        onGridReady={onGridReady}
                        modules={modules} // bắt buộc sử dụng kèm theo @ag-grid-community/react, comment khi sử dụng @ag-grid-react
                        onGridSizeChanged={onGridSizeChanged} //Sự kiện khi size grid thay đổi
                        onFirstDataRendered={onFirstDataRendered} //Func lần đàu gen data
                        onGridPreDestroyed={onGridPreDestroyed}

                        // onPinnedRowDataChanged={onPinnedRowDataChanged}
                        overlayNoRowsTemplate={'<span></span>'} //Func custom template hiển thị khi không có data
                        // debounceVerticalScrollbar={false} // true thì bị lỗi scroll bị chậm load rows
                        suppressRowVirtualisation={!is_vitrual_scroll} // true = tắt vitrual scroll
                        // suppressRowDrag={false} // true = tắt kéo thả dòng
                        // suppressMoveWhenRowDragging={false} // true = tắt hiệu ứng kéo thả dòng
                        rowBuffer={10} // Số row hiển thị ngoài khung, để load trước 1 phần giao diện scroll dự kiến.
                        // #https://www.ag-grid.com/react-data-grid/grid-options/?#reference-scrolling
                        suppressAnimationFrame={true} // FLEXVIX-1300: Sửa kéo scroll bảng giá: Load giao diện bị hiển thị nhiều ô vuông trống.
                        cellFlashDuration={800} // highlight v31.2.1
                        cellFadeDuration={0} // highlight v31.2.1
                        // cellFlashDelay={1000} // highlight v30.2.0
                        // cellFadeDelay={0} // highlight v30.2.0
                        // asyncTransactionWaitMillis={100} // time dong bo thay doi tren giao dien
                        tooltipShowDelay={0} // tooltip
                        tooltipHideDelay={5000} // tooltip https://ag-grid.com/javascript-data-grid/tooltips/
                        // tooltipInteraction={true}

                        suppressContextMenu={true}
                        suppressMenuHide={true}
                        suppressCutToClipboard={true}
                        // suppressCopyRowsToClipboard={true}
                        // suppressCopySingleCellRanges={true}
                        suppressLastEmptyLineOnPaste={true}
                        suppressClipboardPaste={true}
                        suppressClipboardApi={true}
                        suppressFieldDotNotation={true}
                        // suppressMovableColumns={true}
                        suppressColumnMoveAnimation={true}
                        suppressDragLeaveHidesColumns={true}
                        suppressRowGroupHidesColumns={true}
                        suppressAutoSize={true}
                        suppressClickEdit={true}
                        // suppressCsvExport={true}
                        suppressExcelExport={true}
                        // suppressChartToolPanelsButton={true}
                        // suppressTouch={true}
                        suppressFocusAfterRefresh={true}
                        // suppressBrowserResizeObserver={true}
                        suppressPropertyNamesCheck={true}
                        suppressChangeDetection={true}
                        // suppressLoadingOverlay={true}
                        suppressNoRowsOverlay={true}
                        suppressPaginationPanel={true}
                        pivotSuppressAutoColumn={true}
                        suppressExpandablePivotGroups={true}
                        suppressAggFuncInHeader={true}
                        suppressAggFilteredOnly={true}
                        suppressColumnVirtualisation={true}
                        // suppressRowVirtualisation={true}
                        suppressMaxRenderedRowRestriction={true}
                        suppressStickyTotalRow={true}
                        groupSuppressBlankHeader={true}
                        rowGroupPanelSuppressSort={true}
                        suppressGroupRowsSticky={true}
                        suppressMakeColumnVisibleAfterUnGroup={true}
                        suppressModelUpdateAfterUpdateTransaction={true}
                        suppressServerSideFullWidthLoadingRow={true}
                        suppressHorizontalScroll={true}
                        suppressScrollOnNewData={true}
                        suppressScrollWhenPopupsAreOpen={true}
                        // suppressAnimationFrame={true}
                        suppressMiddleClickScrolls={true}
                        suppressPreventDefaultOnMouseWheel={true}
                        // suppressRowDeselection={true}
                        // suppressRowClickSelection={true}
                        // suppressCellFocus={true}
                        suppressHeaderFocus={true}
                        // suppressMultiRangeSelection={true}
                        // suppressClearOnFillReduction={true}
                        suppressMultiSort={true}
                        suppressMaintainUnsortedOrder={true}
                        suppressRowHoverHighlight={true}
                        suppressRowTransform={true}
                    // pagination={true}
                    // paginationPageSize={10} // Chỉ hiển thị
                    />
                </div>
                {/* <div className="realTimeSymbols"> */}
                {
                    (idTablePb && rowData && rowData.length > 0) && (rowData.map((item: any, index: any) => {
                        return (
                            <RenderGridCellRealTimePriceBoard
                                key={`rowData-${idTablePb}-${index}`}
                                idTablePb={idTablePb}
                                // isOddlot={props.isOddlot}
                                // isCorpBondPriceBoard={props.isCorpBondPriceBoard}
                                symbol={item.SB}
                                applyTransactionAsyncRealtime={applyTransactionAsyncRealtime}
                            />
                        )
                    }))
                }
                {/* </div> */}
            </div>

        </div>
        // ) : "LOADING"
        // )

    );
}
export default memo(forwardRef(SymbolSelectorTableNew))